export function getPointProjectCount(
  qoiIds: Set<string>, // new Set(qois.map(({ id }) => id))
  qoiProjectIds: Set<string>, // new Set(qois.map(({ projectId }) => projectId))
  periodValues: { qoiId: string; projectId: string }[],
  driftedProjectIds: string[],
) {
  const projectIds = new Set<string>();
  for (const { projectId } of periodValues.filter(({ qoiId }) => qoiIds.has(qoiId))) {
    projectIds.add(projectId);
  }

  if (qoiProjectIds.size === 0) qoiProjectIds = projectIds;

  let filledCount = 0;
  for (const projectId of driftedProjectIds) {
    if (qoiProjectIds.has(projectId)) filledCount++;
  }

  return {
    filledCount,
    projectCount: projectIds.size,
  };
}
